import { createNode, DurationDataType } from '@glueapp/graph-types';
import { toDuration, fromDuration } from '../../utils/temporal';

export const SubtractDurations = createNode({
    id: 'Subtract Durations',
    name: 'Subtract Durations',
    description: 'Subtracts the second Duration from the first',
    aiDescription:
        'Takes two Duration values on the "First" and "Second" ports and outputs the result of subtracting the second from the first as a Duration on the "Result" port.',
    category: 'Date & Time',
    color: '#3b82f6',
    integration: undefined,
    inPorts: {
        First: DurationDataType,
        Second: DurationDataType,
    },
    outPorts: {
        Result: DurationDataType,
    },
    execute: function (input) {
        const first = toDuration(input.inPorts.First);
        const second = toDuration(input.inPorts.Second);
        const result = first.subtract(second);
        return { output: { Result: fromDuration(result) } };
    },
});
